// Client entry for /conteudos. The page is prerendered on the server (see
// scripts/prerender.mjs) and hydrated here so ContentIndex can reveal scheduled
// posts on their day. Its CSS is already on the page via the shared bundle the
// prerendered HTML links, so we don't re-import styles here.
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { ContentIndex } from "./components/ContentIndex";

const container = document.getElementById("root");
if (container) {
  // Same date the server rendered with (baked onto #root), so the first client
  // render matches the server markup exactly — no hydration mismatch.
  const buildNow = container.dataset.buildDate ?? "";
  hydrateRoot(
    container,
    <StrictMode>
      <ContentIndex buildNow={buildNow} />
    </StrictMode>,
  );
}
